<template>
  <div id="nav" class="app-nav">
    <public-nav v-if="!loggedIn"/>
    <authed-nav v-else/>
  </div>
</template>

<script>
  import { authComputed } from '../../store/helpers';
  import PublicNav from './PublicNav.vue';
  import AuthedNav from './AuthedNav.vue';

  export default {
    components: {
      PublicNav,
      AuthedNav,
    },
    computed: {
      ...authComputed,
    },
  };
</script>
